import React from 'react';
import { BulkEmrModalTemplate } from 'themes/application/facility/components';
import { observer } from 'mobx-react';
import { BulkEmrModalStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';
@setCurrentView((rootStore, componentProps) => new BulkEmrModalStore(rootStore, componentProps), 'bulkEmrModalStore')
@observer
class BulkEmrModal extends React.Component {
    render() {
        return <BulkEmrModalTemplate {...this.props} />
    }
}

export default BulkEmrModal;